// Rive ships ~300 kB of CommonJS glue, so it must never sit in an initial bundle. Every
// consumer goes through here: the module is fetched on first use and the wasm URL is pointed
// at the copy angular.json emits into lib/ (without it Rive falls back to fetching from unpkg).
let riveModule: Promise<typeof import('@rive-app/webgl2')> | undefined;

export function loadRive(): Promise<typeof import('@rive-app/webgl2')> {
  riveModule ??= import('@rive-app/webgl2').then(module => {
    module.RuntimeLoader.setWasmUrl('lib/rive.wasm');
    return module;
  });

  return riveModule;
}
